import { Box, Caption, Heading, Inline, Stack } from '@srichaitra/ui';

/**
 * The standard page frame: a title, an optional supporting line, optional
 * actions, and the page's content below.
 *
 * Every screen uses this, which is what makes heading level, spacing and the
 * position of page actions identical everywhere without each screen having to
 * know what the convention is.
 *
 * The title is always an h2 — h1 belongs to the application name in the shell,
 * and a page that promoted itself to h1 would give the document two.
 */
export function Page({ title, description, actions, children }) {
  return (
    <Stack gap={6}>
      <Inline justify="space-between" align="flex-start">
        <Stack gap={1}>
          <Heading level={2} size="h1">
            {title}
          </Heading>
          {description ? <Caption>{description}</Caption> : null}
        </Stack>

        {actions ? <Inline gap={2}>{actions}</Inline> : null}
      </Inline>

      <Box>{children}</Box>
    </Stack>
  );
}
